<template>
  <v-dialog :value="value" :width="width" @input="$emit('input', $event)">
    <v-card class="py-11 px-16 rounded elevation-0">
      <slot>
        <p class="mb-10 text-center font-20px dark-color--text">
          {{ message }}
        </p>
      </slot>
      <div>
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button"
          :color="confirmColor"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </v-btn>
        <v-btn
          width="100%"
          height="44px"
          elevation="0"
          hide-selected="true"
          class="button mt-2"
          :color="cancelColor"
          @click="onCancel"
        >
          {{ cancelText || $t("Default.cancel") }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AdminConfirmModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "",
    },
    cancelText: {
      type: String,
      default: "",
    },
    confirmColor: {
      type: String,
      default: "main_color white--text",
    },
    cancelColor: {
      type: String,
      default: "sub white--text",
    },
    width: {
      type: [String, Number],
      default: "376",
    },
  },
  methods: {
    onCancel() {
      this.$emit("input", false);
      this.$emit("cancel");
    },
  },
};
</script>
